<template>
  <div class="results-history-filter width-responsiveness">
    <card-form :collapsed="true">
      <div
        slot="expanded"
        class="form-container"
      >
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout
            md-flex="100"
            md-flex-medium="100"
          >
            <h2 class="orders-new__doctor__title title-main">
              Buscar Laudo(s)
            </h2>
          </md-layout>

          <md-layout
            md-flex="33"
            md-flex-medium="33"
          >
            <md-input-container>
              <label>Nome do Paciente</label>
              <md-input
                id="patientName"
                v-model="filter.patientName"
                name="patientName"
                type="text"
                placeholder="Nome do Paciente"
              />
            </md-input-container>
          </md-layout>

          <md-layout
            md-flex="33"
            md-flex-medium="33"
          >
            <md-input-container>
              <label>OS Alvaro</label>
              <md-input
                id="serviceOrder"
                v-model="filter.serviceOrder"
                name="serviceOrder"
                type="text"
                placeholder="OS Alvaro"
              />
            </md-input-container>
          </md-layout>

          <md-layout
            md-flex="33"
            md-flex-medium="33"
            class="box-action"
          >
            <button
              :disabled="resultsHistoryLoadingStatus"
              class="btn btn-primary btn-search"
              @click="getResultsByFilter"
            >
              <md-icon
                md-src="/static/images/icon-search.svg"
                class="icon-search"
              >
                search
              </md-icon>Buscar
            </button>
          </md-layout>
        </md-layout>
      </div>
    </card-form>
  </div>
</template>

<script>
import CardForm from '@/components/common/CardForm'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    CardForm
  },
  data() {
    return {
      filter: {
        serviceOrder: '',
        patientName: ''
      }
    }
  },
  computed: {
    ...mapGetters(['resultsHistoryLoadingStatus'])
  },
  methods: {
    ...mapActions(['getServiceResultsHistory', 'getResultsHistoryFilter']),
    getResultsByFilter() {
      this.filter['page'] = 1

      this.getResultsHistoryFilter(this.filter)
      this.getServiceResultsHistory()
    },
    clearFilters() {
      for (let chave in this.filter) {
        delete this.filter[chave]
      }
    }
  },
  beforeDestroy() {
    this.clearFilters()
  }
}
</script>

<style lang="scss">
.results-history-filter {
  margin-top: 25px;
  margin-bottom: 20px;
  font-family: 'Exo 2', sans-serif !important;

  .card-form__container {
    border-radius: 8px;
    padding-bottom: 0;

    .date-picker {
      .search-bar__date {
        margin: 0;
      }

      label {
        pointer-events: auto;
        top: 0;
        opacity: 1;
        font-size: 12px;
      }

      #datePickerSelect {
        margin: 0;
        padding-top: 10px;
        min-height: inherit;
      }

      #datePickerSingleSelect {
        margin: 0;
        padding-top: 10px;
        min-height: inherit;
      }
    }

    .box-action {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
    }

    .btn-search {
      margin: 4px 0 24px;
      width: 130px;
      text-transform: uppercase;
      font-family: 'Exo 2', sans-serif !important;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 25px;
      font-size: 14px;

      .md-icon {
        margin: 3px 0 0;
      }
    }
  }

  &__checkbox {
    &.md-theme-default.md-checkbox.md-checked .md-checkbox-container {
      background-color: #7f1a54;
      border-color: #7f1a54;
    }
  }

  &__radio {
    display: flex;
    align-items: center;
    width: 350px;
    justify-content: space-between;

    &--flex-start {
      justify-content: flex-start;
      align-items: flex-start;

      .md-radio {
        margin: 16px 50px 16px 0;
      }
    }

    .md-theme-default.md-radio .md-radio-container:after {
      background-color: #7f1a54;
    }

    .md-theme-default.md-radio.md-checked .md-radio-container {
      border-color: #7f1a54;
    }
  }
}
</style>
